function quickSound(){
    this.sounds_bit =[];
    this.queue_fun=[];
    this.otherSound={};
    this.backgroundSound={};
    this.player_error=0;
    this.loaded=0;
    this.mute_obj={};
    this.volume_obj={};
    this.sounds_allways={
        "trigger":{howmany:0},
        "cash_get":{howmany:0},
        "game_bad_word_reach":{howmany:0},
        "new_level_film":{howmany:0},
        "game_cut_bad_word":{howmany:3},
        "game_cut_good_word":{howmany:3},
        "game_score":{howmany:0},
        "girl_heart_appear":{howmany:4},
        "girl_rec":{howmany:0},
        "girl_smile":{howmany:3},
        "jump":{howmany:0},
        "button_click":{howmany:0},
        "hover":{howmany:0},
        "heart_in":{howmany:0},
        "game_success":{howmany:0,addConf:{volume: 0.5}},
    };
    this.sounds_allways_count=0;
    this.sounds_action={
        "bravo":{howmany:0},
        "cash_give":{howmany:0},
        "page_selector":{howmany:0},
        "girl_happy_max":{howmany:0},
        "girl_moan":{howmany:8},
        "girl_moan_new":{howmany:6},
        "girl_play":{howmany:6,addConf:{loop:true}},
        "girl_org":{howmany:2},
        "pvplick":{howmany:3},
        "pvpsuck":{howmany:3},
        "pvpgo_start":{howmany:0},
        "pvpgo_end":{howmany:0},
        "pvpfinish":{howmany:0},
        "mmoan":{howmany:3,addConf:{volume: 0.8}},
        "victory":{howmany:0},
        "chick":{howmany:4},
        "chick_happy":{howmany:3},
        "chick_die":{howmany:0},
        "bunny_win":{howmany:0},
        "egg_crash":{howmany:0},
        "glass_crush":{howmany:0},
        "shower":{howmany:0,addConf:{loop:true}},
        "window_clean":{howmany:2},
        "soccer_crowd":{howmany:0,addConf:{loop:true,volume: 0.5}},
        "soccer_defend":{howmany:0},
        "soccer_gate":{howmany:0},
        "soccer_net":{howmany:0},
        "soccer_shot":{howmany:0},
        "soccer_slide":{howmany:0},
        "soccer_target":{howmany:0},
        "soccer_explosion":{howmany:0},
        "game_lose":{howmany:0},
        "soccer_whistle_start":{howmany:0},
        "soccer_whistle_end":{howmany:0},
        "beach_background":{howmany:0,addConf:{loop:true,volume: 0.4}},
        "crab_in":{howmany:0},
        "crab_out":{howmany:0},
        "crab_whistle":{howmany:0},
        "girl_scared":{howmany:3},
        "crab_move":{howmany:2,addConf:{loop:true}},
        "pain":{howmany:2},
        "pain_like":{howmany:0},
        "before_punch":{howmany:0},
        "punch":{howmany:2},
        "card":{howmany:0},
        "click_tiny":{howmany:0},
        "girlnew_alice_background":{howmany:0,addConf:{loop:true}},
        "girlnew_alice_auto_in":{howmany:0},
        "girlnew_alice_auto_out":{howmany:0},
        "girlnew_alice_police":{howmany:0,addConf:{loop:true}},
        "hall_back":{howmany:0,addConf:{loop:true}},
        "hall_cat_claws":{howmany:0,addConf:{loop:true,volume: 0.2}},
        "hall_cat_cut":{howmany:0},
        "hall_cat_start":{howmany:0},
        "hall_magic":{howmany:0},
        "hall_pumpkin_cut":{howmany:0},
        "hall_witch_cut":{howmany:0},
        "hall_witch_start":{howmany:2},
        "hall_bat_cut":{howmany:0},
        "poker_cash":{howmany:0},
        "poker_next":{howmany:0},
        "poker_own":{howmany:0},
        "dildo_smash":{howmany:0,addConf:{loop:true,volume: 0.5}},
        "cuffs":{howmany:0},
        "drone":{howmany:0,addConf:{loop:true,volume: 0.5}},
        "intruder":{howmany:0},
        "walk_lose_all":{howmany:0},
        "walk_lose_life":{howmany:0},
        "jetski":{howmany:0,addConf:{loop:true,volume: 0.2}},
        "dobble_ouch":{howmany:0},
        "dobble_punch":{howmany:0},
        "dobble_win":{howmany:3},
        "dobble_yeah":{howmany:0},
        "hall2019_bubble":{howmany:0},
        "hall2019_wand":{howmany:0,addConf:{volume: 0.4}},
        "hall2019_scream":{howmany:0},
        "coin_3good":{howmany:0},
        "coin_fight":{howmany:0},
        "coin_start_play":{howmany:0},
        "coin_stop":{howmany:0},
        "ninjasummer_girl":{howmany:2},
        "ninjasummer_girlup":{howmany:0},
        "ninjasummer_boy":{howmany:0},
        "ninjasummer_panda":{howmany:0},
    };
    this.sounds_background=[
        "main"
    ];
};
quickSound.prototype={
    init:function(){
//        return false;
        try{


            var tmp=_myStorage.getJson("flSoundObj");
            if(!tmp || typeof tmp.music=="undefined"){
                tmp={music:0,sound:0};
            }
            this.mute_obj=copyObj(tmp);

            var tmp=_myStorage.getJson("flVolumeObj");
            if(!tmp || typeof tmp.music=="undefined"){
                tmp={music:75,sound:100};
            }
            this.volume_obj=copyObj(tmp);

            var i,name,bum,realThis=this,volume;
            for(name in this.sounds_allways){
                bum=this.sounds_allways[name];
                volume=this.volume_obj["sound"]/100;
                if(typeof bum.addConf!="undefined" && typeof bum.addConf.volume!="undefined"){
                    volume=bum.addConf.volume*volume;
                }
                if(bum.howmany==0){
                    var conf={
                        src: ["/music/"+name+".mp3","/music/"+name+".ogg"],
                        "onload":function(){realThis.myLoader();}
                    };
                    if(typeof bum.addConf!="undefined"){
                        conf=$.extend(conf,bum.addConf);
                    }
                    conf.volume=volume;
                    this.otherSound[name]=new Howl(conf);
                    this.sounds_allways_count++;
                }
                else{
                    this.sounds_allways_count+=bum.howmany;
                    for(i=1;i<=bum.howmany;i++){
                        var conf={
                            src: ["/music/"+name+i+".mp3","/music/"+name+i+".ogg"],
                            "onload":function(){realThis.myLoader();}
                        };
                        if(typeof bum.addConf!="undefined"){
                            conf=$.extend(conf,bum.addConf);
                        }
                        conf.volume=volume;
                        this.otherSound[(name+i)]=new Howl(conf);
                    }
                }

            }
            for(name in this.sounds_action){
                bum=this.sounds_action[name];
                volume=this.volume_obj["sound"]/100;
                if(typeof bum.addConf!="undefined" && typeof bum.addConf.volume!="undefined"){
                    volume=bum.addConf.volume*volume;
                }
                if(bum.howmany==0){
                    var conf={
                        src: ["/music/"+name+".mp3","/music/"+name+".ogg"],
                        preload:false
                    };
                    if(typeof bum.addConf!="undefined"){
                        conf=$.extend(conf,bum.addConf);
                    }
                    conf.volume=volume;
                    this.otherSound[name]=new Howl(conf);
                }
                else{
                    for(i=1;i<=bum.howmany;i++){
                        var conf={
                            src: ["/music/"+name+i+".mp3","/music/"+name+i+".ogg"],
                            preload:false
                        };
                        if(typeof bum.addConf!="undefined"){
                            conf=$.extend(conf,bum.addConf);
                        }
                        conf.volume=volume;
                        this.otherSound[(name+i)]=new Howl(conf);
                    }
                }

            }
            for(i in this.sounds_background){
                name=this.sounds_background[i];
                this.backgroundSound[name]=new Howl({
                    src: ["/music/"+name+".mp3","/music/"+name+".ogg"],
                    preload:false,
                    volume:this.volume_obj.music/100,
                    loop:true,
                    "onload":function(){
                        if(realThis.mute_obj.music==1){
                            realThis.stopBackground();
                        }
                    }
                });
            }
            $("body").one("click.musicTrigger",function(){
               if(realThis.playSound("trigger")){
                   $("body").off("click.musicTrigger");
               }
               if(realThis.mute_obj.music==0){
                   realThis.playBackground("main");
               }

            });

            $("#profileContent .buttonCircle.sound").click(function(){
                realThis.howlerToggle();
            });
            this.howlerSet();
        }
        catch(e){}
    },
    myLoader:function(){
        this.loaded++;
    },
    stopBackground:function(){
        try{
            var i;
            for(i in this.backgroundSound){
                if(this.backgroundSound[i].state()=="loaded"){
                    this.backgroundSound[i].pause();
                }
            }
        }
        catch(e){}
    },
    playBackground:function(name_str){
      return false;
        try{
            if(_ON_DEV=="michal"){
    //            return false;
            }
            if(typeof this.backgroundSound[name_str]=="undefined"){
                return false;
            }
            if(this.mute_obj.music==1){
                return false;
            }
            if(this.backgroundSound[name_str].state()!="loaded"){
                var curThis=this;
                this.backgroundSound[name_str].once('load',function(){
                    curThis.playBackground(name_str);
                });
                this.backgroundSound[name_str].load();
            }
            else{
                this.stopBackground();
                this.backgroundSound[name_str].play();
            }
        }
        catch(e){}
    },
    stopSound:function(name){
//        return false;
        try{
            if(typeof this.otherSound[name]!="undefined"){
                this.otherSound[name].stop();
            }
        }
        catch(e){}
    },
    stopSoundAll:function(){
        try{
            var i;
            for(i in this.otherSound){
                if(this.otherSound[i].state()=="loaded"){
                    this.otherSound[i].stop();
                }
            }
        }
        catch(e){}
    },
    playSound:function(name,onStart){
        try{
            if(this.mute_obj.sound){
                return false;
            }
    //        return false;
            var conf;
            if(typeof this.sounds_action[name]!="undefined"){
                conf=this.sounds_action[name];
            }
            else if(typeof this.sounds_allways[name]!="undefined"){
                conf=this.sounds_allways[name];
            }
            else{
                return false;
            }
            if(conf.howmany>0){
                name=name+mt_rand(1,conf.howmany)
            }


            if(this.otherSound[name].state()!="loaded"){
                var curThis=this;
                this.otherSound[name].once('load',function(){
                    curThis.otherSound[name].play();
                    if(typeof onStart=="function"){
                        onStart(name);
                    }
                });
                this.otherSound[name].load();
            }
            else{
                this.otherSound[name].play();
                if(typeof onStart=="function"){
                    onStart(name);
                }
            }

            return name;
        }
        catch(e){return false;}

    },
    takeSoundDuration:function(name_real){
        try{
            if(typeof this.otherSound[name_real]=="undefined"){
                return false;
            }
            return this.otherSound[name_real].duration();
        }
        catch(e){return false;}
    },
    howlerToggle:function(){
        try{
            if(this.mute_obj.music==1 && this.mute_obj.sound==1 ){
                this.mute_obj.music=0;
                this.mute_obj.sound=0;
            }
            else{
                this.mute_obj.music=1;
                this.mute_obj.sound=1;
            }

            _myStorage.setJson("flSoundObj",this.mute_obj);
            this.howlerSet();
            _eventHandler.trigger("howlerMute",copyObj(this.mute_obj));
        }
        catch(e){}
    },
    howlerSetVal:function(type,mute){
        try{
            this.mute_obj[type]=mute;
            _myStorage.setJson("flSoundObj",this.mute_obj);
            this.howlerSet();
        }
        catch(e){}
    },

    setMusicVolumeVal:function(val){
        try{
            this.volume_obj["music"]=val;
            _myStorage.setJson("flVolumeObj",this.volume_obj);

            var i;
            for(i in this.backgroundSound){
                this.backgroundSound[i].volume(this.volume_obj["music"]/100);
            }
        }
        catch(e){}
    },
    setSoundVolumeVal:function(val){
        try{
            this.volume_obj["sound"]=val;
            _myStorage.setJson("flVolumeObj",this.volume_obj);

            var i,name,bum,realThis=this,volume;

            for(name in this.sounds_allways){
                bum=this.sounds_allways[name];
                volume=this.volume_obj["sound"]/100;
                if(typeof bum.addConf!="undefined" && typeof bum.addConf.volume!="undefined"){
                    volume=bum.addConf.volume*volume;
                }
                if(bum.howmany==0){
                    if(typeof this.otherSound[name]!="undefined"){
                        this.otherSound[name].volume(volume);
                    }
                }
                else{
                    for(i=1;i<=bum.howmany;i++){
                        if(typeof this.otherSound[(name+i)]!="undefined"){
                            this.otherSound[(name+i)].volume(volume);
                        }
                    }
                }

            }
            for(name in this.sounds_action){
                bum=this.sounds_action[name];
                volume=this.volume_obj["sound"]/100;
                if(typeof bum.addConf!="undefined" && typeof bum.addConf.volume!="undefined"){
                    volume=bum.addConf.volume*volume;
                }
                if(bum.howmany==0){
                    if(typeof this.otherSound[name]!="undefined"){
                        this.otherSound[name].volume(volume);
                    }
                }
                else{
                    for(i=1;i<=bum.howmany;i++){
                        if(typeof this.otherSound[(name+i)]!="undefined"){
                            this.otherSound[(name+i)].volume(volume);
                        }
                    }
                }
            }
        }
        catch(e){}
    },
    takeVolumeObj:function(){
        return copyObj(this.volume_obj);
    },
    takeMuteObj:function(){
        return copyObj(this.mute_obj);
    },
    howlerSet:function(){
        try{
            var state="off";
            if(this.mute_obj.music==1 && this.mute_obj.sound==1 ){
                state="on";
            }
            $("#profileContent .buttonCircle.sound").attr("data-type",state);
            if(this.mute_obj.music==0){
                this.playBackground("main");
            }
            else{
                this.stopBackground();
            }
            if(this.mute_obj.sound==1){
                this.stopSoundAll();
            }
        }
        catch(e){}

    }
};



var _mySound=new quickSound();

$(function(){
    _mySound.init();
});
